import { createSlice } from '@reduxjs/toolkit';
import { initState } from './init.state';
import {
  FetchApiKeysAsync,
  CreateApiKeyAsync,
  RevokeApiKeyAsync,
} from './async.thunks';

export const ApiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState: initState,
  reducers: {
    ClearLastCreatedKey: (state) => {
      state.lastCreatedKey = null;
    },
    ClearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch API Keys
    builder.addCase(FetchApiKeysAsync.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(FetchApiKeysAsync.fulfilled, (state, action) => {
      state.loading = false;
      state.apiKeys = action.payload.apiKeys;
    });
    builder.addCase(FetchApiKeysAsync.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to fetch API keys';
    });

    // Create API Key
    builder.addCase(CreateApiKeyAsync.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(CreateApiKeyAsync.fulfilled, (state, action) => {
      state.loading = false;
      state.lastCreatedKey = action.payload.createdKey;
      // Add to list (without the actual key value)
      const { apiKey, ...keyWithoutSecret } = action.payload.createdKey;
      state.apiKeys.push(keyWithoutSecret as any);
    });
    builder.addCase(CreateApiKeyAsync.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to create API key';
    });

    // Revoke API Key
    builder.addCase(RevokeApiKeyAsync.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(RevokeApiKeyAsync.fulfilled, (state, action) => {
      state.loading = false;
      // Update key status in list
      const keyIndex = state.apiKeys.findIndex(
        (k) => k.name === action.payload.keyName
      );
      if (keyIndex >= 0) {
        state.apiKeys[keyIndex].isActive = false;
      }
    });
    builder.addCase(RevokeApiKeyAsync.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Failed to revoke API key';
    });
  },
});

export const { ClearLastCreatedKey, ClearError } = ApiKeysSlice.actions;
export { FetchApiKeysAsync, CreateApiKeyAsync, RevokeApiKeyAsync, AuditApiKeysAsync } from './async.thunks';
export default ApiKeysSlice.reducer;
